import gql from 'graphql-tag'

export const NOTIFY_REMOVE_FAVORITE = gql`
  mutation NotifyRemoveFavorite($productErpIdentifier: String!) {
    notifyRemoveFavorite(productErpIdentifier: $productErpIdentifier)
  }
`
